export const dateTimeFormat = (
  date: string | number | Date,
  locales?: Intl.LocalesArgument,
  options?: Intl.DateTimeFormatOptions
): string => {
  return new Date(date).toLocaleString(locales, {
    hour12: true,
    dateStyle: "medium",
    timeStyle: "short",
    ...options
  });
};
export const dateFormat = (
  date: string | number | Date,
  locales?: Intl.LocalesArgument,
  options?: Intl.DateTimeFormatOptions
): string => {
  return new Date(date).toLocaleDateString(locales, {
    dateStyle: "medium",
    ...options
  });
};
export const removeExtension = (fileName: string) => fileName.split(".").slice(0, -1).join(".");

export const formatNumbers = (
  num: number,
  options: Intl.NumberFormatOptions | undefined = {},
  locales?: string | string[]
) => {
  // console.log("formatNumbers", number);
  const f = new Intl.NumberFormat(locales, options);
  return f.format(num);
};
export const formatTime = (
  time: number,
  unit: Intl.RelativeTimeFormatUnit = "seconds",
  options: Intl.RelativeTimeFormatOptions | undefined = {},
  locales?: string | string[]
) => {
  // console.log("formatNumbers", number);
  const f = new Intl.RelativeTimeFormat(locales, options);
  return f.format(time, unit);
};
